import { z } from 'zod';

const validator = z.preprocess((website) => {
    if (typeof website === 'string' && website.trim()) {
        return website.replaceAll(' ', '').replace('http://', 'https://');
    }

    return null;
}, z.string().url().nullable().default(null));

export const Website = {
    validator,
};
